import React from "react";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

// Material-UI Icon
import PersonIcon from "@material-ui/icons/Person";
import GroupIcon from "@material-ui/icons/Group";
import EmailIcon from "@material-ui/icons/Email";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import WarningIcon from "@material-ui/icons/Warning";
import Typography from "@material-ui/core/Typography";
import ClearIcon from "@material-ui/icons/Clear";

// Global Function
import { avatarTypeColor } from "../../global/avatarColor";

// Custom Style
import { whiteColor, redColor, grayColor } from "../../styles/jss/cmsMainStyle";
import rfiRecipientChipStyle from "../../styles/jss/components/chip/recipientChipStyle";

const ChipContentTypography = withStyles({
  root: {
    fontSize: 12,
    fontWeight: 400,
    color: grayColor[10],
  },
})(Typography);

const useStyles = makeStyles((theme) => rfiRecipientChipStyle(theme));

const RFIRecipientChip = (props) => {
  const classes = useStyles();
  const {
    id,
    rcptType,
    rcptName,
    recipientType,
    removeAction,
    handleRecipientClipClick,
    is_attachment_readable,
    site_user_seq,
    submissionValue,
    setSubmissionValue,
    isNew,
    editable,
    group_seq,
    actionButton,
    // setisAttachmentReadable,
  } = props;

  const setAttchmentReadable = (site_user_seq) => {
    if (isNew || editable) {
      if (rcptType === "USER") {
        let data = { ...submissionValue };
        data.recipients[recipientType].filter(
          (obj) => obj.site_user_seq === site_user_seq
        )[0].is_attachment_readable =
          data.recipients[recipientType].filter(
            (obj) => obj.site_user_seq === site_user_seq
          )[0].is_attachment_readable === "N"
            ? "Y"
            : "N";
        setSubmissionValue({ ...submissionValue, ...data });
      } else if (rcptType === "USERGROUP") {
        let data = { ...submissionValue };
        data.recipients[recipientType].filter(
          (obj) => obj.group_seq === group_seq
        )[0].is_attachment_readable =
          data.recipients[recipientType].filter(
            (obj) => obj.group_seq === group_seq
          )[0].is_attachment_readable === "N"
            ? "Y"
            : "N";
        setSubmissionValue({ ...submissionValue, ...data });
      }
    }
  };

  const canReadTitle =
    is_attachment_readable === "Y"
      ? "Can Read Attachment"
      : "Cannot Read Attachment";

  return (
    // <Paper variant="outlined" className={classes.paper}>
    //   {recipientType !== "TO" && (
    //     <Tooltip title={`Can Read Attachment:${canRead}`} aria-label="read">
    //       <AttachFileIcon
    //         fontSize="small"
    //         color={is_attachment_readable === "Y" ? "secondary" : "action"}
    //         className={classes.attachment}
    //         onClick={() => {
    //           setAttchmentReadable(site_user_seq);
    //         }}
    //       />
    //     </Tooltip>
    //   )}

    //   <Chip
    //     key={id}
    //     avatar={
    //       <Avatar
    //         className={classes.avatar}
    //         style={{
    //           "--avatar-color": avatarTypeColor(rcptType),
    //         }}
    //       >
    //         {rcptType === "USER" ? (
    //           <PersonIcon fontSize="small" />
    //         ) : rcptType === "USERGROUP" ? (
    //           <GroupIcon fontSize="small" />
    //         ) : rcptType === "EMAIL" ? (
    //           <EmailIcon fontSize="small" />
    //         ) : (
    //           <WarningIcon fontSize="small" />
    //         )}
    //       </Avatar>
    //     }
    //     label={rcptName}
    //     variant="outlined"
    //     className={classes.chip}
    //     clickable
    //     // onDelete={removeAction !== null ? removeAction : ""}
    //     onDelete={removeAction}
    //     onClick={
    //       rcptType === "USERGROUP"
    //         ? handleRecipientClipClick
    //         : rcptType === "USER"
    //         ? null
    //         : null
    //     }
    //   />
    // </Paper>
    <div className={classes.root}>
      <Paper
        variant="outlined"
        className={classes.paper}
        onClick={
          rcptType === "USERGROUP"
            ? handleRecipientClipClick
            : rcptType === "USER"
            ? null
            : null
        }
      >
        <Avatar
          className={classes.avatar}
          style={{
            "--avatar-color": avatarTypeColor(rcptType),
          }}
        >
          {rcptType === "USER" ? (
            <PersonIcon fontSize="small" />
          ) : rcptType === "USERGROUP" ? (
            <GroupIcon fontSize="small" />
          ) : rcptType === "EMAIL" ? (
            <EmailIcon fontSize="small" />
          ) : (
            <WarningIcon fontSize="small" />
          )}
        </Avatar>

        <div className={classes.chipContent}>
          <ChipContentTypography>{rcptName}</ChipContentTypography>
        </div>

        <div className={classes.actionBtnGroup}>
          {recipientType !== "TO" && (
            <Tooltip title={canReadTitle} aria-label="read">
              <Avatar className={classes.actionBtn}>
                <IconButton
                  className={classes.actionBtnIcon}
                  aria-label="attachment"
                  onClick={() => {
                    setAttchmentReadable(site_user_seq);
                  }}
                  style={{
                    "--icon-color":
                      is_attachment_readable === "Y" ? redColor[5] : whiteColor,
                  }}
                >
                  <AttachFileIcon />
                </IconButton>
              </Avatar>
            </Tooltip>
          )}
          {removeAction ? (
            <Avatar className={classes.actionBtn}>
              <IconButton
                className={classes.actionBtnIcon}
                aria-label="remove"
                onClick={removeAction}
                style={{
                  "--icon-color": whiteColor,
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </Avatar>
          ) : (
            ""
          )}
        </div>
      </Paper>
    </div>
  );
};

export default RFIRecipientChip;
